import { Flex } from '@sendoutcards/quantum-design-ui'
import React, { FC } from 'react'
import { useAccount, useState } from 'src/hooks'
import { PlanFragment } from 'src/legacy_graphql'
import { PlanIdType } from 'src/pricing_page/components/pricingTile/PlanTiles'

import { DialogUpsaleCheckout } from 'src/upsale/components/checkout/DialogUpsaleCheckout'
import { SubscriptionSelection } from './SubscriptionSelection'

type AccountSubscriptionChangerProps = {
  subscriptionPlanIds: PlanIdType[]
  selectedItemCallback?: (item: PlanFragment) => void // If this is omitted the quick checkout will be used
  isOpen: boolean
  onClose: () => void
}

export const AccountSubscriptionChanger: FC<AccountSubscriptionChangerProps> = ({
  subscriptionPlanIds,
  isOpen,
  onClose,
}) => {
  const account = useAccount()
  const currentPlan = account.plan
  const [selPlan, setSelPlan] = useState<PlanFragment | undefined>(currentPlan)
  const [showCheckout, setShowCheckout] = useState<boolean>(false)

  // const queryParams = useQueryParams()
  const handleOpenSubscriptionCheckout = (plan: PlanFragment) => {
    setSelPlan(plan)
    setShowCheckout(true)
  }
  const handleCloseSubscriptionCheckout = () => {
    setSelPlan(undefined)
    setShowCheckout(false)
    onClose()
  }

  return (
    <Flex>
      <SubscriptionSelection
        planIds={subscriptionPlanIds}
        isOpen={isOpen}
        onSelectPlan={(plan: PlanFragment) =>
          handleOpenSubscriptionCheckout(plan)
        }
        buttonTitle={'Add Subscription'}
        currentPlan={currentPlan}
        onClose={() => onClose()}
      />
      {selPlan && showCheckout && (
        <DialogUpsaleCheckout
          selectedItem={selPlan}
          onClose={() => handleCloseSubscriptionCheckout()}
        />
      )}
    </Flex>
  )
}
